import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _parseInt from '@babel/runtime-corejs3/core-js/parse-int';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js/instance/slice';
import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js/object/define-property';
import React, { forwardRef, useRef, useImperativeHandle, useState, useCallback, useEffect, useMemo, createRef } from 'react';
import { IconTickFillSmall, IconXMarkCircleFill, IconExclamationMarkTriangleFill } from '@byted-tiktok/tux-icons';
import { TUXSpinner } from '../TUXLoading/TUXSpinner.js';
import { TUXTextFieldFooter } from './TUXTextFieldFooter.js';
import { TUXTextFieldHeader } from './TUXTextFieldHeader.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function getStyleValue(computedStyle, property) {
  return _parseInt(computedStyle[property], 10) || 0;
}

function getNextInputVal(e, inputRef) {
  var _context;

  var currentVal = inputRef.current === null ? '' : inputRef.current.value; // backspace will trigger inputEvent with e.data = null on some UAs

  var inputData = e.data === null ? '' : e.data;

  var nextVal = _concatInstanceProperty(_context = "".concat(currentVal)).call(_context, inputData);

  return nextVal;
}
/**
 * Native Input props
 */


var _ref2 = /*#__PURE__*/React.createElement(TUXSpinner, {
  size: 20,
  className: "text-color-TextTertiary mx-4"
});

var TUXTextFieldWIP = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      name = _ref.name,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      placeholder = _ref.placeholder,
      readOnly = _ref.readOnly,
      inputMode = _ref.inputMode,
      minLength = _ref.minLength,
      maxLength = _ref.maxLength,
      _ref$canExceedMaxLeng = _ref.canExceedMaxLength,
      canExceedMaxLength = _ref$canExceedMaxLeng === void 0 ? false : _ref$canExceedMaxLeng,
      lines = _ref.lines,
      maxLines = _ref.maxLines,
      autoSize = _ref.autoSize,
      autoFocus = _ref.autoFocus,
      disabled = _ref.disabled,
      hasClearButton = _ref.hasClearButton,
      hasError = _ref.hasError,
      errorMessage = _ref.errorMessage,
      isPassed = _ref.isPassed,
      isValidating = _ref.isValidating,
      shouldPreventInputEventFn = _ref.shouldPreventInputEventFn,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onReadOnlyClick = _ref.onReadOnlyClick,
      onDisabledClick = _ref.onDisabledClick,
      title = _ref.title,
      subtitle = _ref.subtitle,
      footer = _ref.footer,
      hasCounter = _ref.hasCounter,
      _ref$hasBottomBorder = _ref.hasBottomBorder,
      hasBottomBorder = _ref$hasBottomBorder === void 0 ? true : _ref$hasBottomBorder,
      start = _ref.start,
      end = _ref.end,
      dir = _ref.dir,
      textAlign = _ref.textAlign;
  var inputRef = /*#__PURE__*/createRef();
  var shadowRef = /*#__PURE__*/createRef();
  var isComposingRef = useRef(false);
  useImperativeHandle(ref, function () {
    return inputRef.current;
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocus = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      autoSizeState = _useState4[0],
      setAutoSizeState = _useState4[1];

  var isControlled = value !== undefined;

  var _useState5 = useState(isControlled ? value : defaultValue),
      _useState6 = _slicedToArray(_useState5, 2),
      internalValue = _useState6[0],
      setInternalValue = _useState6[1];

  var valueLength = internalValue !== undefined ? internalValue.length : 0;
  var syncHeight = useCallback(function () {
    var _context2;

    if (!autoSize || type !== 'multiline') {
      return;
    }

    var input = inputRef.current;

    if (!input) {
      return;
    }

    var containerWindow = input.ownerDocument.defaultView || window;
    var computedStyle = containerWindow.getComputedStyle(input); // If input's width is shrunk and it's not visible, don't sync height.

    if (computedStyle.width === '0px') {
      return;
    }

    var inputShallow = shadowRef.current;

    if (!inputShallow) {
      return;
    }

    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || placeholder || 'x';

    if (_sliceInstanceProperty(_context2 = inputShallow.value).call(_context2, -1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }

    var boxSizing = computedStyle.boxSizing;
    var padding = getStyleValue(computedStyle, 'paddingBottom') + getStyleValue(computedStyle, 'paddingTop');
    var border = getStyleValue(computedStyle, 'borderBottomWidth') + getStyleValue(computedStyle, 'borderTopWidth'); // The height of the inner content

    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content

    var outerHeight = innerHeight;

    if (lines) {
      outerHeight = Math.max(Number(lines) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight);

    if (maxLines && maxLines > 0) {
      outerHeight = Math.min(outerHeight, Number(maxLines) * singleRowHeight);
    } // Take the box sizing into account for applying this value as a style.


    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setAutoSizeState(function (prevState) {
      if (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow) {
        return {
          overflow: overflow,
          outerHeightStyle: outerHeightStyle
        };
      }

      return prevState;
    });
  }, [inputRef, placeholder, shadowRef, autoSize, type, lines, maxLines]);
  var changeHandler = useCallback(function (e) {
    if (!canExceedMaxLength && maxLength !== undefined && e.target.value.length > maxLength) {
      e.preventDefault();
      return;
    }

    if (isComposingRef.current) {
      // when isComposing, we should always maintain the internal value
      // and do not notify this change
      setInternalValue(e.target.value);
      return;
    } // handle uncontrolled changes


    if (!isControlled) {
      setInternalValue(e.target.value);
    }

    onChange && onChange(e);
  }, [isControlled, onChange, setInternalValue, maxLength, canExceedMaxLength]); // handle controlled changes

  useEffect(function () {
    if (isControlled) {
      setInternalValue(value);
    }
  }, [value, isControlled]);
  var clickHandler = useCallback(function () {
    if (readOnly) {
      return onReadOnlyClick === null || onReadOnlyClick === void 0 ? void 0 : onReadOnlyClick();
    }

    if (disabled) {
      return onDisabledClick === null || onDisabledClick === void 0 ? void 0 : onDisabledClick();
    }
  }, [readOnly, disabled, onReadOnlyClick, onDisabledClick]);
  var focusHandler = useCallback(function (e) {
    setFocus(true);
    onFocus && onFocus(e);
  }, [onFocus]);
  var blurHandler = useCallback(function (e) {
    setFocus(false);
    onBlur && onBlur(e);
  }, [onBlur]);
  var clearHandler = useCallback(function (e) {
    if (disabled || readOnly) {
      return;
    }

    if (!isControlled) {
      setInternalValue('');
    }

    if (!inputRef.current) {
      return;
    }

    var fakeChangeEvent = _objectSpread(_objectSpread({}, e), {}, {
      target: inputRef.current,
      currentTarget: inputRef.current
    });

    fakeChangeEvent.target.value = '';
    onChange && onChange(fakeChangeEvent);
    inputRef.current.focus();
  }, [isControlled, disabled, inputRef, onChange, readOnly, setInternalValue]);
  var typeToPreventInputEventFn = useMemo(function () {
    return {
      number: function number(e, _inputRef) {
        var numberRegex = inputMode === 'numeric' ? /^\d+$/ : /^\d+\.?\d*$/;
        var nextVal = getNextInputVal(e, _inputRef);
        return !numberRegex.test(nextVal);
      }
    };
  }, [inputMode]);
  var beforeInputHandler = useCallback(function (e) {
    if (readOnly || disabled) {
      e.preventDefault();
      return;
    }

    var shouldPreventInputEvent = shouldPreventInputEventFn || typeToPreventInputEventFn[type];

    if (shouldPreventInputEvent !== undefined && shouldPreventInputEvent(e, inputRef)) {
      e.preventDefault();
    }
  }, [inputRef, shouldPreventInputEventFn, type, typeToPreventInputEventFn, readOnly, disabled]);
  var handleComposition = useCallback(function (e) {
    if (e.type === 'compositionstart') {
      isComposingRef.current = true;
    } else if (e.type === 'compositionend') {
      isComposingRef.current = false;
      changeHandler(e);
    }
  }, [changeHandler]);
  useEffect(function () {
    syncHeight();
  });
  var isMultiline = type === 'multiline';
  var InputComponent = useMemo(function () {
    return isMultiline ? 'textarea' : 'input';
  }, [isMultiline]);
  var suffixIcon = useMemo(function () {
    if (isValidating) {
      return _ref2;
    }

    if (isPassed) {
      return /*#__PURE__*/React.createElement(IconTickFillSmall, {
        style: {
          fontSize: 20
        },
        className: "text-color-Positive flex-shrink-0 mx-4"
      });
    }

    if (hasClearButton) {
      return /*#__PURE__*/React.createElement(IconXMarkCircleFill, {
        className: 'text-color-TextQuaternary mx-8' + (!isFocus || valueLength === 0 ? " hidden" : ""),
        style: {
          fontSize: 16
        },
        onClick: clearHandler,
        onMouseDown: function onMouseDown(e) {
          e.preventDefault();
        }
      });
    }

    return null;
  }, [clearHandler, hasClearButton, valueLength, isFocus, isPassed, isValidating]);
  var autoSizeStyle = useMemo(function () {
    if (!autoSize) {
      return {};
    }

    return {
      height: autoSizeState.outerHeightStyle,
      // Need a large enough difference to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: autoSizeState.overflow ? 'hidden' : ''
    };
  }, [autoSize, autoSizeState.outerHeightStyle, autoSizeState.overflow]);
  useEffect(function () {
    var inputEl = inputRef.current; // React and Preact has inconsistent support for composition event

    if (inputEl) {
      inputEl.addEventListener('compositionstart', handleComposition);
      inputEl.addEventListener('compositionupdate', handleComposition);
      inputEl.addEventListener('compositionend', handleComposition);
    }

    return function () {
      if (inputEl) {
        inputEl.removeEventListener('compositionstart', handleComposition);
        inputEl.removeEventListener('compositionupdate', handleComposition);
        inputEl.removeEventListener('compositionend', handleComposition);
      }
    };
  }, [inputRef, handleComposition]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(TUXTextFieldHeader, {
    title: title,
    subtitle: subtitle,
    hasCounter: hasCounter,
    length: valueLength,
    maxLength: maxLength,
    shouldHighlightCounter: maxLength !== undefined ? valueLength > maxLength : false
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col box-border"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center",
    onClick: clickHandler
  }, start, /*#__PURE__*/React.createElement("div", {
    className: "flex-1",
    style: {
      padding: '15px 0'
    }
  }, /*#__PURE__*/React.createElement(InputComponent, {
    className: 'tt-text-field--input H4-Regular text-color-TextPrimary w-full appearance-none background-color-transparent p-0 m-0' + (isMultiline ? " pt-4" : ""),
    ref: inputRef,
    name: name,
    type: isMultiline ? 'text' : type,
    value: internalValue,
    placeholder: placeholder,
    autoFocus: autoFocus,
    readOnly: readOnly,
    disabled: disabled,
    inputMode: inputMode,
    minLength: minLength,
    rows: lines,
    onChange: changeHandler,
    onFocus: focusHandler,
    onBlur: blurHandler // @ts-ignore till React properly supports InputEvent
    ,
    onBeforeInput: beforeInputHandler,
    dir: dir,
    style: _objectSpread(_objectSpread({}, autoSizeStyle), {}, {
      textAlign: textAlign,
      lineHeight: isMultiline ? '18px' : '20px'
    })
  }), isMultiline && autoSize && /*#__PURE__*/React.createElement("textarea", {
    "aria-hidden": true,
    className: "tt-text-field--input absolute H4-Regular text-color-TextPrimary w-full appearance-none background-color-BGPrimary p-0 m-0 pt-4",
    readOnly: true,
    ref: shadowRef,
    tabIndex: -1,
    dir: dir,
    style: {
      // Visibility needed to hide the extra text area on iPads
      visibility: 'hidden',
      // Ignore the scrollbar width
      overflow: 'hidden',
      height: 0,
      top: 0,
      left: 0,
      // Create a new layer, increase the isolation of the computed values
      transform: 'translateZ(0)',
      textAlign: textAlign
    }
  })), suffixIcon, end), hasBottomBorder && /*#__PURE__*/React.createElement("div", {
    className: "tt-text-field--divider " + (hasError ? 'background-color-Negative' : 'background-color-LineInput')
  }), hasError && errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mt-8 text-color-Negative flex items-center P1-Regular"
  }, /*#__PURE__*/React.createElement(IconExclamationMarkTriangleFill, {
    className: "self-start",
    style: {
      fontSize: '16px'
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "mx-8"
  }, errorMessage))), footer && /*#__PURE__*/React.createElement(TUXTextFieldFooter, null, footer));
});
TUXTextFieldWIP.displayName = 'TUXTextFieldWIP';

export { TUXTextFieldWIP };
//# sourceMappingURL=TUXTextField.js.map
